import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgCommonModule } from '@principle-theorem/ng-shared';
import { MarketingCampaignStepConversionStatus } from '@principle-theorem/principle-core/interfaces';
import {
  MarketingStatusColour,
  MarketingStatusIcon,
} from '../../campaign-status/marketing-status-display';
import { IconChipComponent } from '../../icon-chip/icon-chip.component';

const statusColourMap: {
  [key in MarketingCampaignStepConversionStatus]: string;
} = {
  [MarketingCampaignStepConversionStatus.Pending]: MarketingStatusColour.Draft,
  [MarketingCampaignStepConversionStatus.Queued]: MarketingStatusColour.Draft,
  [MarketingCampaignStepConversionStatus.Disabled]:
    MarketingStatusColour.Warning,
  [MarketingCampaignStepConversionStatus.Skipped]:
    MarketingStatusColour.Success,
  [MarketingCampaignStepConversionStatus.Completed]:
    MarketingStatusColour.Success,
  [MarketingCampaignStepConversionStatus.Converted]:
    MarketingStatusColour.Success,
  [MarketingCampaignStepConversionStatus.Failed]: MarketingStatusColour.Error,
  [MarketingCampaignStepConversionStatus.Cancelled]:
    MarketingStatusColour.Warning,
  [MarketingCampaignStepConversionStatus.Unsubscribed]:
    MarketingStatusColour.Warning,
  [MarketingCampaignStepConversionStatus.Unenrolled]:
    MarketingStatusColour.Warning,
  [MarketingCampaignStepConversionStatus.ExceededCommunicationLimit]:
    MarketingStatusColour.Error,
};

const statusIconMap: {
  [key in MarketingCampaignStepConversionStatus]: string;
} = {
  [MarketingCampaignStepConversionStatus.Pending]: MarketingStatusIcon.Pending,
  [MarketingCampaignStepConversionStatus.Queued]: MarketingStatusIcon.Running,
  [MarketingCampaignStepConversionStatus.Disabled]:
    MarketingStatusIcon.Cancelled,
  [MarketingCampaignStepConversionStatus.Skipped]: MarketingStatusIcon.Skipped,
  [MarketingCampaignStepConversionStatus.Completed]:
    MarketingStatusIcon.Complete,
  [MarketingCampaignStepConversionStatus.Converted]:
    MarketingStatusIcon.Complete,
  [MarketingCampaignStepConversionStatus.Failed]: MarketingStatusIcon.Failed,
  [MarketingCampaignStepConversionStatus.Cancelled]:
    MarketingStatusIcon.Cancelled,
  [MarketingCampaignStepConversionStatus.Unsubscribed]:
    MarketingStatusIcon.Exit,
  [MarketingCampaignStepConversionStatus.Unenrolled]: MarketingStatusIcon.Exit,
  [MarketingCampaignStepConversionStatus.ExceededCommunicationLimit]:
    MarketingStatusIcon.Failed,
};

@Component({
  selector: 'pr-campaign-step-conversion-status',
  imports: [NgCommonModule, IconChipComponent, MatTooltipModule],
  templateUrl: './campaign-step-conversion-status.component.html',
  styleUrl: './campaign-step-conversion-status.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CampaignStepConversionStatusComponent {
  @Input() status?: MarketingCampaignStepConversionStatus;
  @Input() tooltip?: string;

  statusColor(status?: MarketingCampaignStepConversionStatus): string {
    return status ? statusColourMap[status] : MarketingStatusColour.Draft;
  }

  statusIcon(status?: MarketingCampaignStepConversionStatus): string {
    return status ? statusIconMap[status] : MarketingStatusIcon.Unknown;
  }
}
